import { createSelector } from '@ngrx/store';
import { getCartDeliveryAddress } from '../getCartDeliveryAddress';

export const isCartDeliveryAddressValid = createSelector(
    getCartDeliveryAddress,
    deliveryAddress => !!deliveryAddress
);
